import { defineStore } from 'pinia'
import { debounce } from '../libs/helpTools'
import { DISPLAYS } from '../libs/helpConsts'
export const useWindowStore = defineStore('window', {
  state: () => ({
    windowWidth: 0
  }),
  getters: {
    isMobile () {
      return this.windowWidth <= DISPLAYS.WIDE_SM
    },

    isTablet () {
      return this.windowWidth > DISPLAYS.WIDE_SM && this.windowWidth <= DISPLAYS.LG
    },

    isDesktop () {
      return this.windowWidth > DISPLAYS.LG
    },

    isMediaMaxMd () {
      return this.windowWidth <= DISPLAYS.MD
    },

    isMediaMaxWideSm () {
      return this.windowWidth <= DISPLAYS.WIDE_SM
    },

    isMediaMaxSm () {
      return this.windowWidth <= DISPLAYS.SM
    }
  },
  actions: {
    setWidth (width = window.innerWidth) {
      this.windowWidth = width
    }
  }
})

export const initResize = () => {
  const windowStore = useWindowStore()
  windowStore.setWidth()
  const setWidth = debounce(windowStore.setWidth, 50)
  window.addEventListener('resize', () => {
    setWidth()
  })
}
